import { cn } from '@/shadcn-ui/utils';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { colors } from '@/theme/colors';

export default function ChevronDownThick({
  className,
  fillPrimary = colors.neutral60,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
    >
      <path
        d="M4.33834 9.95989L11.0428 16.5788C11.3218 16.8596 11.6424 17 12.0045 17C12.1885 17 12.3576 16.9628 12.512 16.8883C12.6722 16.8195 12.8236 16.7163 12.9661 16.5788L19.6528 9.95989C19.8843 9.74785 20 9.48138 20 9.16046C20 8.94269 19.9466 8.74499 19.8397 8.56734C19.7329 8.39542 19.5875 8.25788 19.4034 8.15473C19.2254 8.05158 19.0265 8 18.8069 8C18.4626 8 18.1718 8.11748 17.9343 8.35244L11.6038 14.6361H12.414L6.06567 8.35244C5.82823 8.11748 5.53738 8 5.1931 8C4.97347 8 4.77166 8.05158 4.58765 8.15473C4.40957 8.25788 4.26711 8.39542 4.16027 8.56734C4.05342 8.74499 4 8.94269 4 9.16046C4 9.31519 4.02671 9.46132 4.08013 9.59885C4.13949 9.73639 4.22556 9.85673 4.33834 9.95989Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
